import React from 'react';
import Sidebar from '../components/Sidebar';
import ContentHeader from '../components/ContentHeader';

const ArtifactsPage = () => {
  return (
    <div className="columns" style={{ height: '100vh', display: 'flex', flexDirection: 'row' }}>
      <Sidebar />
      <div className="column p-6 has-background-light">
        <ContentHeader title="Artifacts" subtitle="Manage your stored artifacts"/>
      </div>
    </div>
  );
};

export default ArtifactsPage;
